import { Component, DOCUMENT, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-public-layout',
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.css'
})
export class PublicLayoutComponent implements OnInit {
  parentRouteName: any = "";
  // This method is used to initialize the class instance using language service, router, route, and location
  constructor(private languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    @Inject(DOCUMENT) private document: Document
  ) {

  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    const parentRoute = this.route;
    if (parentRoute) {
      const parentPath = parentRoute.snapshot.routeConfig?.path;
      this.parentRouteName = parentPath ?? null;
    }
    this.languageService.initLanguage();
  }
  // This method is used to back
  back() {
    // this.location.back();
    this.router.navigate(["/dashboard"])
  }
  get isPlatinumTheme(): boolean {
    return !!this.document?.body?.classList.contains('platinum-theme');
  }
  get currentLogo(): string {
    return this.isPlatinumTheme ? '/images/logo-navy.png' : '/images/logo.png';
  }

  onLogoDoubleClick(event: MouseEvent): void {
    if (!event.shiftKey) {
      return;
    }
    this.languageService.toggleLanguage();
  }
}
